//imports
import {
    asyncGetConfigSettings, asyncUpdateAvatarPack,
    asyncUpdateColorConfiguration, asyncUpdateModeration,
    asyncUpdateGeneral, asyncUpdateCommentsTree, asyncUpdateCommunity, asyncUploadImage
} from 'utils/api/commenting';
import { displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui';
import { batchActions } from "redux-batched-actions";
// constants
// general
export const UPDATE_GENERAL = 'UPDATE_GENERAL';
export const UPDATE_GENERAL_TEXT = 'UPDATE_GENERAL_TEXT';
export const VALIDATE_GENERAL_TEXT = 'VALIDATE_GENERAL_TEXT';
export const UPDATE_GENERAL_ADVANCE_SETTINGS = 'UPDATE_GENERAL_ADVANCE_SETTINGS';
export const UPLOADING_LOGO = 'UPLOADING_LOGO';
export const SAVING_GENERAL = 'SAVING_GENERAL';
export const SAVE_GENERAL = 'SAVE_GENERAL';
//moderation
export const UPDATE_MODERATION = 'UPDATE_MODERATION';
export const UPDATE_MODERATION_ADVANCE_SETTINGS = 'UPDATE_MODERATION_ADVANCE_SETTINGS';
export const SAVING_MODERATION = 'SAVING_MODERATION';
export const SAVE_MODERATION = 'SAVE_MODERATION';
//community
export const UPDATE_COMMUNITY = 'UPDATE_COMMUNITY';
export const SAVING_COMMUNITY = 'SAVING_COMMUNITY';
export const SAVE_COMMUNITY = 'SAVE_COMMUNITY';

export const GET_CONFIGURATION = 'GET_CONFIGURATION';
export const SET_COMMENTING_UNIT_UUID = 'SET_COMMENTING_UNIT_UUID';
export const FETCHING_CONFIGURATION = 'FETCHING_CONFIGURATION';
export const FETCHING_FAIL = 'FETCHING_FAIL';

export const SAVING_COLOR_CONFIGURATION = 'SAVING_COLOR_CONFIGURATION';
export const SAVE_COLOR_CONFIGURATION = 'SAVE_COLOR_CONFIGURATION';

export const SAVING_AVATAR_PACK = 'SAVING_AVATAR_PACK';
export const SAVE_AVATAR_PACK = 'SAVE_AVATAR_PACK';

// comments tree
export const UPDATE_COMMENTS_TREE = 'UPDATE_COMMENTS_TREE';
export const SAVING_COMMENTS_TREE = 'SAVING_COMMENTS_TREE';
export const SAVE_COMMENTS_TREE = 'SAVE_COMMENTS_TREE';

export const CANCEL_SECTION = 'CANCEL_SECTION';


// actions

// general section
export const updateGeneralSettings = (prop, value) => ({
    type: UPDATE_GENERAL,
    prop,
    value
});

export const updateGeneralText = (prop, value) => ({
    type: UPDATE_GENERAL_TEXT,
    prop,
    value
});

export const validateGeneralText = (prop, valid) => ({
    type: VALIDATE_GENERAL_TEXT,
    prop,
    valid
});

export const updateAdvanceSettings = (prop, value) => ({
    type: UPDATE_GENERAL_ADVANCE_SETTINGS,
    prop,
    value
});

const savingGeneral = status => ({
    type: SAVING_GENERAL,
    status
});

const saveGeneral = () => ({
    type: SAVE_GENERAL
});

const uploadingLogo = status => ({
    type: UPLOADING_LOGO,
    status
})

const uploadImageSuccess = (url) => batchActions([uploadingLogo(false)]);
const uploadImageFail = () => batchActions([displayErrorMessage('There was an issue uploading your image!'), uploadingLogo(false)]);

//moderation section

export const updateModerationSettings = (prop, value) => ({
    type: UPDATE_MODERATION,
    prop,
    value
});

export const updateModerationAdvanceSettings = (prop, value) => ({
    type: UPDATE_MODERATION_ADVANCE_SETTINGS,
    prop,
    value
});

const savingModeration = status => ({
    type: SAVING_MODERATION,
    status
});

const saveModeration = () => ({
    type: SAVE_MODERATION
});

export const cancelSectionChanges = (section) => ({
    type: CANCEL_SECTION,
    section
});

const receiveConfiguration = data => ({
    type: GET_CONFIGURATION,
    data
});

export const setCommentingUnitUUID = (comentingUnitUUID) => ({
    type: SET_COMMENTING_UNIT_UUID,
    data: comentingUnitUUID
});

const configuratioinFailed = () => ({
    type: FETCHING_FAIL
});

const fetchingConfiguration = status => ({
    type: FETCHING_CONFIGURATION,
    status
});

const savingColorConfiguration = status => ({
    type: SAVING_COLOR_CONFIGURATION,
    status
});

const saveColorConfiguration = data => ({
    type: SAVE_COLOR_CONFIGURATION,
    data
});

const savingAvatarPack = status => ({
    type: SAVING_AVATAR_PACK,
    status
});

const saveAvatarPack = (data) => ({
    type: SAVE_AVATAR_PACK,
    data
});

// community section
export const updateCommunity = (prop, value) => ({
    type: UPDATE_COMMUNITY,
    prop,
    value
});

const savingCommunity = status => ({
    type: SAVING_COMMUNITY,
    status
});

const saveCommunity = data => ({
    type: SAVE_COMMUNITY,
    data
});


// batched actions
const fetchConfigurationFail = () => batchActions([
    fetchingConfiguration(false),
    configuratioinFailed(),
    displayErrorMessage('There was a problem fetching your commenting settings for this site.')
]);

const saveColorConfigurationSuccess = (data) => batchActions([
    savingColorConfiguration(false),
    saveColorConfiguration(data),
    displaySuccessMessage('Color scheme updated.')
]);

const saveColorConfigurationFail = () => batchActions([
    savingColorConfiguration(false),
    displayErrorMessage('There was an issue updating the color scheme.')
]);

//genera
const saveGeneralSuccess = () => batchActions([
    savingGeneral(false),
    saveGeneral(),
    displaySuccessMessage('General updated.')
]);

const saveGeneralFail = () => batchActions([
    savingGeneral(false),
    displayErrorMessage('There was an issue updating your general settings.')
]);

//moderation
const saveModerationSuccess = () => batchActions([
    savingModeration(false),
    saveModeration(),
    displaySuccessMessage('Moderation updated.')
]);

const saveModerationFail = () => batchActions([
    savingModeration(false),
    displayErrorMessage('There was an issue updating your moderation settings.')
]);

const saveAvatarPackSuccess = (data) => batchActions([
    savingAvatarPack(false),
    saveAvatarPack(data),
    displaySuccessMessage('User Avatars updated.')
]);

const saveAvatarPackFail = () => batchActions([
    savingAvatarPack(false),
    displayErrorMessage('There was an issue updating the avatar pack')
]);

export const updateCommentsTree = (prop, value) => ({
    type: UPDATE_COMMENTS_TREE,
    prop,
    value
});

const savingCommentsTree = status => ({
    type: SAVING_COMMENTS_TREE,
    status
});

const saveCommentsTree = () => ({
    type: SAVE_COMMENTS_TREE
});

const saveCommentsTreeSuccess = () => batchActions([
    savingCommentsTree(false),
    saveCommentsTree(),
    displaySuccessMessage('Comments Tree updated.')
]);

const saveCommentsTreeFail = () => batchActions([
    savingCommentsTree(false),
    displayErrorMessage('There was an issue updating the comments tree.')
]);

const saveCommunitySuccess = (data) => batchActions([
    savingCommunity(false),
    saveCommunity(data),
    displaySuccessMessage('Community updated.')
]);

const saveCommunityFail = () => batchActions([
    savingCommunity(false),
    displayErrorMessage('There was an issue updating the community.')
]);

// thunks

export const getConfiguration = (accountUUID, siteUUID, siteURL, callback) => dispatch => {
    dispatch(fetchingConfiguration(true));
    asyncGetConfigSettings(accountUUID, siteUUID, siteURL)
        .then(response => {
            if(callback) callback()
            dispatch(receiveConfiguration(response.data))
        })
        .catch(err => dispatch(fetchConfigurationFail()))
}

export const updateColorConfiguration = (colorConfigurationUUID, colorScheme, collapse) => dispatch => {
    dispatch(savingColorConfiguration(true));
    asyncUpdateColorConfiguration(colorConfigurationUUID, colorScheme)
        .then(response => {
            collapse && collapse();
            dispatch(saveColorConfigurationSuccess(colorScheme))
        })
        .catch(err => dispatch(saveColorConfigurationFail()))
}

export const updateModeration = (moderationUUID, data, collapse) => dispatch => {
    dispatch(savingModeration(true));
    asyncUpdateModeration(moderationUUID, data)
        .then(response => {
            collapse && collapse();
            dispatch(saveModerationSuccess())
        })
        .catch(err => dispatch(saveModerationFail()))
}

export const updateGeneral = (configUUID, data, collapse) => dispatch => {
    dispatch(savingGeneral(true));
    asyncUpdateGeneral(configUUID, data)
        .then(response => {
            collapse && collapse();
            dispatch(saveGeneralSuccess())
        })
        .catch(err => dispatch(saveGeneralFail()))
}

export const updateAvatarPack = (commentingUnitConfigurationUUID, avatarPack, collapse) => dispatch => {
    dispatch(savingAvatarPack(true));
    asyncUpdateAvatarPack(commentingUnitConfigurationUUID, avatarPack)
        .then(response => {
            if (response.status === 200) {
                collapse && collapse();
                dispatch(saveAvatarPackSuccess(avatarPack.avatarPack))
            } else {
                dispatch(saveAvatarPackFail())
            }
        })
        .catch(err => dispatch(saveAvatarPackFail()))
}

export const updateCommentsTreeData = (commentTreeConfigurationUUID, commentsTree, collapse) => dispatch => {
    dispatch(savingCommentsTree(true));
    asyncUpdateCommentsTree(commentTreeConfigurationUUID, commentsTree)
        .then(response => {
            if (response.status === 200) {
                collapse && collapse();
                dispatch(saveCommentsTreeSuccess());
            } else {
                dispatch(saveCommentsTreeFail());
            }
        })
        .catch(err => dispatch(saveCommentsTreeFail()))
}

export const updateCommunityData = (communityConfigurationUUID, communityData, collapse) => dispatch => {
    dispatch(savingCommunity(true));
    asyncUpdateCommunity(communityConfigurationUUID, communityData)
        .then(response => {
            if (response.status === 200) {
                collapse && collapse();
                dispatch(saveCommunitySuccess(communityData.state));
            } else {
                dispatch(saveCommunityFail());
            }
        })
        .catch(err => dispatch(saveCommunityFail()))
}
